'use strict';

var React = require('react');
var Bookmark = require('../../../IconsAndImages/Icons/Bookmark.js');
var BookmarkBorder = require('../../../IconsAndImages/Icons/BookmarkBorder.js');
var Tooltip = require('../../../DesignSystem/DataDisplay/Tooltips/Tooltip.js');
var Typography = require('../../../DesignSystem/DataDisplay/Typography/Typography.js');
var ChevronRight = require('../../../IconsAndImages/Icons/ChevronRight.js');
var StatusInfo = require('./StatusInfo.js');
var CheckCircle = require('../../../IconsAndImages/Icons/CheckCircle.js');
var makeStyles = require('../../../node_modules/@material-ui/core/esm/styles/makeStyles.js');
var colorManipulator = require('../../../node_modules/@material-ui/core/esm/styles/colorManipulator.js');
var Checkbox = require('../../../node_modules/@material-ui/core/esm/Checkbox/Checkbox.js');
var IconButton = require('../../../node_modules/@material-ui/core/esm/IconButton/IconButton.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var useBookmarkStyles = makeStyles(function (theme) {
  return {
    iconContainer: {
      display: 'flex',
      color: theme.palette.common.black
    }
  };
});

var BookmarkIcon = function BookmarkIcon(_ref) {
  var _ref$isFilled = _ref.isFilled,
      isFilled = _ref$isFilled === void 0 ? false : _ref$isFilled;
  var classes = useBookmarkStyles();
  return React__default["default"].createElement("div", {
    className: classes.iconContainer
  }, isFilled ? React__default["default"].createElement(Bookmark, {
    width: 18,
    height: 18,
    color: "inherit"
  }) : React__default["default"].createElement(BookmarkBorder, {
    width: 18,
    height: 18,
    color: "inherit"
  }));
};

var useUnitCardStyles = makeStyles(function (theme) {
  return {
    root: {
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column'
    },
    bookmark: {
      margin: theme.spacing(-1.25)
    },
    layout: {
      padding: theme.spacing(1, 2),
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      color: 'common.black',
      whiteSpace: 'initial'
    },
    arrowIcon: {
      paddingLeft: theme.spacing(0.25),
      marginRight: theme.spacing(-0.75)
    },
    statusContainer: function statusContainer(_ref2) {
      var isCompleted = _ref2.isCompleted;
      return {
        marginTop: 'auto',
        display: 'flex',
        justifyContent: 'space-between',
        padding: theme.spacing(1.25, 2),
        backgroundColor: isCompleted ? colorManipulator.fade(theme.palette.success.light, 0.65) : 'transparent'
      };
    },
    statusInfo: {
      flexGrow: 1
    },
    completedIcon: {
      display: 'flex',
      color: theme.palette.success.main,
      flexShrink: 0,
      flexGrow: 0,
      margin: theme.spacing(-0.375, 1),
      marginRight: 0
    },
    saveButton: {
      flexGrow: 0,
      flexShrink: 0,
      marginLeft: 1
    }
  };
});

var UnitCardInfo = function UnitCardInfo(_ref3) {
  var title = _ref3.title,
      status = _ref3.status,
      isSaved = _ref3.isSaved,
      _ref3$showArrowIcon = _ref3.showArrowIcon,
      showArrowIcon = _ref3$showArrowIcon === void 0 ? false : _ref3$showArrowIcon,
      percentage = _ref3.percentage,
      isSavedFeatureEnabled = _ref3.isSavedFeatureEnabled,
      setIsHoverDisabled = _ref3.setIsHoverDisabled,
      onBookmarkStateChange = _ref3.onBookmarkStateChange;
  var isCompleted = status === 'completed';
  var tooltip = isSaved ? 'Remove from saved' : 'Save for later';
  var classes = useUnitCardStyles({
    isCompleted: isCompleted
  });
  var bookmarkButton = isSavedFeatureEnabled ? React__default["default"].createElement("div", {
    className: classes.saveButton
  }, React__default["default"].createElement("div", {
    className: classes.bookmark
  }, React__default["default"].createElement(Tooltip, {
    title: tooltip
  }, React__default["default"].createElement(Checkbox["default"], {
    onClick: function onClick(evt) {
      evt.stopPropagation();
    },
    checked: isSaved,
    onChange: function onChange(_, savedValue) {
      onBookmarkStateChange && onBookmarkStateChange(savedValue);
    },
    onMouseOver: function onMouseOver() {
      setIsHoverDisabled(true);
    },
    onMouseLeave: function onMouseLeave() {
      setIsHoverDisabled(false);
    },
    icon: React__default["default"].createElement(BookmarkIcon, null),
    checkedIcon: React__default["default"].createElement(BookmarkIcon, {
      isFilled: true
    })
  })))) : null;
  return React__default["default"].createElement("div", {
    className: classes.root
  }, React__default["default"].createElement("div", {
    className: classes.layout
  }, React__default["default"].createElement(Typography, {
    version: "v2",
    variant: "subtitle1"
  }, title), showArrowIcon ? React__default["default"].createElement("div", {
    className: classes.arrowIcon
  }, React__default["default"].createElement(IconButton["default"], {
    size: "small"
  }, React__default["default"].createElement(ChevronRight, null))) : null), React__default["default"].createElement("div", {
    className: classes.statusContainer
  }, React__default["default"].createElement("div", {
    className: classes.statusInfo
  }, React__default["default"].createElement(StatusInfo, {
    status: status,
    percentage: percentage,
    isSavedFeatureEnabled: isSavedFeatureEnabled
  })), isCompleted ? React__default["default"].createElement("div", {
    className: classes.completedIcon
  }, React__default["default"].createElement(CheckCircle, {
    color: "inherit"
  })) : bookmarkButton));
};

module.exports = UnitCardInfo;
